import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as LogoutSvg } from "../../assets/images/logoutsvg.svg";
import { Button } from "./Button";
import { clearUserInfo, hideIdleModal, hideLoginModal, logout } from "../../store/auth/authSlice";
import { useNavigate } from "react-router-dom";
import { setClearClaimDetails } from "../../store/claim/claimSlice";
import { useLogOutUserMutation } from "../../store/auth/usersApiSlice";
import { AUTH_EVENTS, postAuthEvent } from "../../utils/authChannel";

export const Logout = ({ close }) => {
  const { token } = useSelector((state) => state.auth);
  const [logOutUser] = useLogOutUserMutation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = async (e) => {
    e.preventDefault();
    await logOutUser({ token });

    // Tell the other tabs before clearing this one. They share the cookies
    // that were just revoked, so without this they keep rendering a signed-in
    // UI until their next 401 — which on an idle dashboard may never come.
    postAuthEvent(AUTH_EVENTS.SIGNED_OUT);

    dispatch(hideIdleModal());
    dispatch(logout());
    dispatch(hideLoginModal());
    dispatch(setClearClaimDetails())
    dispatch(clearUserInfo());
    navigate('/');
  };

  return (
    <div className="text-center flex items-center flex-col pt-4 px-2">
      <LogoutSvg />
      <h3 className="text-secondarytwo text-center text-f20 font-semibold my-2">
        Comeback Soon!
      </h3>
      <p className="text-secondary pb-4 w-64 px-6 text-f16">
        Are you sure you want to logout from TREVEX?
      </p>
      <hr className="w-full" />
      <div className="flex text-secondary pt-4 w-full gap-4">
        <Button
          onClick={close}
          classes="bg-primary px-4 py-2 text-white text-f14 rounded w-full"
        >
          Cancel
        </Button>
        <Button
          onClick={handleLogout}
          classes="bg-primary px-4 py-2 text-white text-f14 rounded w-full"
        >
          Logout
        </Button>
      </div>
    </div>
  );
};
